import React from 'react';

function Refund() {
  return (
    <div className="flex my-[50px] justify-center">
      <div className="w-[900px] h-[700px] p-16 overflow-auto shadow-xl">
        <h1 className="text-[#003478]  font-extrabold text-2xl text-center ">
          {' '}
          Cancellation & Refund
        </h1>
        <hr className="my-8 h-1 " />

        <p className="font-extrabold text-lg  my-4  ">Cancellation Policy </p>

        <p>
          In case of a cancellation, the premium paid for an insurance product
          will be refunded via cheque or direct credit as per the policy of the
          Insurance Provider that you have chosen to buy the product from. You
          do not need to return the copy of the policy documents received by
          you, in order to cancel the policy.
        </p>
        <p className="font-extrabold text-lg  my-4  ">Refund Policy</p>

        <p>
          In case of a refund due to an erroneous transaction or cancellation,
          the premium paid for an insurance product will be refunded via cheque
          or direct credit as per the policy of the Insurance provider that you
          have chosen to buy the product from.
        </p>
      </div>
    </div>
  );
}

export default Refund;
